import { ReportsVisitsRoutes, ReportsVisitsNames, ReportsVisitsLabelName } from './models/reports-visits.enums';
import { ReportsOpportunityPermissions, ReportsOpportunityRoutes } from './models/reports-opportunity.enums';
import { ReportsLeadsPermissions, ReportsLeadsRoutes, ReportsLeadsTypes } from './models/reports-leads.enums';
import { ReportsActivityRoutes, ReportsAccountRoutes, ReportsCaseRoutes, ReportsPermissionNames, ReportsAuditRoutes } from './models/reports.models';
import { ReportsInventoryRoutes, ReportsInventoryNames, ReportsInventoryLabelName } from './models/reports-inventory.models';
import { ReportsLoginsRoutes } from './models/reports-login.enums';
import { ReportsQuestionairePermissions, ReportsQuestionaireRoutes } from './models/reports-questionaire.enums';
import { ReportsFinanceLabelName, ReportsFinanceNames, ReportsFinanceReportNames, ReportsFinanceRoutes } from './models/reports-finance.models';
import { ReportsUserActivityRoutes } from './models/reports-activity.enums';
import { ReportsAuditPermissions } from './models/reports-audit.models';


export const reportsMenuData = [

    // {
    //     label: "My Fav",
    //     expanded: false,
    //     reportType: "myfav_reports",
    //     permissionName: "",
    //     route: null,
    //     items: []
    // },
    {
        label: "CRM",
        expanded: false,
        reportType: "crm_reports",
        permissionName: "",
        route: null,
        haveCharts: true,
        items: [
            // {
            //     label: "Activity",
            //     expanded: false,
            //     visible: false,
            //     reportType: "activity_reports",
            //     permissionName: "Activity Report",
            //     route: "activity",
            //     haveCharts: false,
            //     items: [
            //         {
            //             label: "Activity Analytic Report Summary",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "activityAnalyticReportSummary",
            //             permissionName: "Activity Analytic Report Summary",
            //             route: ReportsActivityRoutes.activityAnalyticReportSummary
            //         },
            //         {
            //             label: "Activity Analytic Report Detail",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "activityAnalyticReportDetail",
            //             permissionName: "Activity Analytic Report Detail",
            //             route: ReportsActivityRoutes.activityAnalyticReportDetail
            //         },
            //         {
            //             label: "Outbound Call Report",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "outboundCallReport",
            //             permissionName: "Outbound Call Report",
            //             route: ReportsActivityRoutes.outboundCallReport
            //         },
            //         {
            //             label: "Outbound Call Required",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "outboundCallRequired",
            //             permissionName: "Outbound Call Required",
            //             route: ReportsActivityRoutes.outboundCallRequired
            //         },
            //         {
            //             label: "Inbound Call Report",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "inboundCallReport",
            //             permissionName: "Inbound Call Report",
            //             route: ReportsActivityRoutes.inboundCallReport
            //         },
            //         {
            //             label: "Top 10 Activity User",
            //             reportName: "Top 10 Activity User",
            //             escape: false,
            //             visible: false,
            //             reportType: "top10ActivityUser",
            //             permissionName: "",
            //             route: ReportsActivityRoutes.top10ActivityUser
            //         }
            //     ]
            // },
            // {
            //     label: "Accounts",
            //     expanded: false,
            //     visible: false,
            //     reportType: "accounts_reports",
            //     permissionName: "",
            //     route: "accounts",
            //     items: [
            //         {
            //             label: "Activity Report",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "accountsActivityReport",
            //             permissionName: "Activity Report",
            //             route: ReportsAccountRoutes.accountsActivityReport
            //         },
            //         {
            //             label: "No Activity Report",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "accountsNoActivityReport",
            //             permissionName: "No Activity Report",
            //             route: ReportsAccountRoutes.accountsNoActivityReport
            //         },
            //         {
            //             label: "Key Accounts Summary",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "keyAccountsReportSummary",
            //             permissionName: "Key Accounts Summary",
            //             route: ReportsAccountRoutes.keyAccountsReportSummary
            //         },
            //         {
            //             label: "Key Accounts Details",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "keyAccountsReportDetails",
            //             permissionName: "Key Accounts Details",
            //             route: ReportsAccountRoutes.keyAccountsReportDetails
            //         }
            //     ]
            // },
            // {
            //     label: "Cases",
            //     expanded: false,
            //     visible: false,
            //     reportType: "cases_reports",
            //     permissionName: "Cases Report",
            //     route: "cases",
            //     items: [
            //         {
            //             label: "Cases By Category Summary",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesByCategorySummary",
            //             permissionName: "Cases By Category Summary",
            //             route: ReportsCaseRoutes.casesByCategorySummary
            //         },
            //         {
            //             label: "Cases By Category Details",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesByCategoryDetails",
            //             permissionName: "Cases By Category Details",
            //             route: ReportsCaseRoutes.casesByCategoryDetails
            //         },
            //         {
            //             label: "Cases By Rep Summary",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesByRepSummary",
            //             permissionName: "Cases By Rep Summary",
            //             route: ReportsCaseRoutes.casesByRepSummary
            //         },
            //         {
            //             label: "Cases By Rep Details",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesByRepDetails",
            //             permissionName: "Cases By Rep Details",
            //             route: ReportsCaseRoutes.casesByRepDetails
            //         },
            //         {
            //             label: "Cases By Source Summary",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesBySourceSummary",
            //             permissionName: "Cases By Source Summary",
            //             route: ReportsCaseRoutes.casesBySourceSummary
            //         },
            //         {
            //             label: "Cases By Source Details",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesBySourceDetails",
            //             permissionName: "Cases By Source Details",
            //             route: ReportsCaseRoutes.casesBySourceDetails
            //         },
            //         {
            //             label: "Cases By Accounts",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesByAccounts",
            //             permissionName: "Cases By Accounts",
            //             route: ReportsCaseRoutes.casesByAccounts
            //         },
            //         {
            //             label: "Cases By Leads",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "casesByLeads",
            //             permissionName: "Cases By Leads",
            //             route: ReportsCaseRoutes.casesByLeads
            //         }
            //     ]
            // },
            {
                label: "Leads",
                expanded: false,
                visible: false,
                reportType: "leads_reports",
                permissionName: "Lead Report",
                route: "leads",
                haveCharts: true,
                items: [
                    {
                        label: "Closed Leads By Owner",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsLeadsTypes.leadsOwner,
                        permissionName: ReportsLeadsPermissions.leadsOwner,
                        route: ReportsLeadsRoutes.leadsOwner,
                        haveCharts: true
                    },
                    {
                        label: "Lead By Stage",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsLeadsTypes.leadsStage,
                        permissionName: ReportsLeadsPermissions.leadsStage,
                        route: ReportsLeadsRoutes.leadsStage,
                        haveCharts: true
                    },
                    // {
                    //     label: "Lead By Activity",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsActivity,
                    //     permissionName: "Lead By Activity",
                    //     route: ReportsLeadsRoutes.leadsActivity
                    // },
                    // {
                    //     label: "Lead By Industry",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsIndustry,
                    //     permissionName: "Lead By Industry",
                    //     route: ReportsLeadsRoutes.leadsIndustry
                    // },
                    // {
                    //     label: "Lead By Conversion",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsConversion,
                    //     permissionName: "Lead By Conversion",
                    //     route: ReportsLeadsRoutes.leadsConversion
                    // },
                    // {
                    //     label: "Lead By Conversion Summary",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsConversionSummary,
                    //     permissionName: "Lead By Conversion Summary",
                    //     route: ReportsLeadsRoutes.leadsConversionSummary
                    // },
                    // {
                    //     label: "Lead By Type",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsType,
                    //     permissionName: "Lead By Type",
                    //     route: ReportsLeadsRoutes.leadsType
                    // },
                    // {
                    //     label: "Lead By Source",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsSource,
                    //     permissionName: "Lead By Source",
                    //     route: ReportsLeadsRoutes.leadsSource
                    // },
                    // {
                    //     label: "Lead By Create Date",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsCreatedate,
                    //     permissionName: "Lead By Create Date",
                    //     route: ReportsLeadsRoutes.leadsCreatedate
                    // },
                    // {
                    //     label: "Lead By No Activity",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsNoActivity,
                    //     permissionName: "Lead By No Activity",
                    //     route: ReportsLeadsRoutes.leadsNoActivity
                    // },
                    // {
                    //     label: "Lead By Aging",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsAging,
                    //     permissionName: "Lead By Aging",
                    //     route: ReportsLeadsRoutes.leadsAging
                    // },
                    // {
                    //     label: "Lead By Converted",
                    //     reportName: "",
                    //     escape: false,
                    //     visible: false,
                    //     reportType: ReportsLeadsTypes.leadsConverted,
                    //     permissionName: "Lead By Converted",
                    //     route: ReportsLeadsRoutes.leadsConverted
                    // }
                ]
            },
            {
                label: "Opportunity",
                expanded: false,
                visible: false,
                reportType: "opportunity_reports",
                permissionName: "Opportunity Report",
                route: "opportunity",
                haveCharts: true,
                items: [
                    {
                        label: "Closed Won Summary",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "closedwonopportunitysummary",
                        permissionName: ReportsOpportunityPermissions.closedwonopportunitysummary,
                        route: ReportsOpportunityRoutes.closedwonopportunitysummary
                    },
                    {
                        label: "Closed Won By Owner",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "closedwonopportunitydetail",
                        permissionName: ReportsOpportunityPermissions.closedwonopportunitydetail,
                        route: ReportsOpportunityRoutes.closedwonopportunitydetail,
                        haveCharts: true
                    },
                    {
                        label: "Open Opportunities By Owner",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "openopportunitybyowner",
                        permissionName: ReportsOpportunityPermissions.openopportunitybyowner,
                        route: ReportsOpportunityRoutes.openopportunitybyowner,
                        haveCharts: false
                    },
                    {
                        label: "Opportunity by Stage Summary",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "opportunitybycloseddatestagesummary",
                        permissionName: ReportsOpportunityPermissions.opportunitybycloseddatestagesummary,
                        route: ReportsOpportunityRoutes.opportunitybycloseddatestagesummary,
                        haveCharts: true
                    },
                    {
                        label: "Opportunity by Stage Details",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "opportunitybycloseddatestagedetail",
                        permissionName: ReportsOpportunityPermissions.opportunitybycloseddatestagedetail,
                        route: ReportsOpportunityRoutes.opportunitybycloseddatestagedetail,
                        haveCharts: true
                    },
                    {
                        label: "Opportunity Performance by Sales Person",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "winlosssalesanalysis",
                        permissionName: ReportsOpportunityPermissions.winlosssalesanalysis,
                        route: ReportsOpportunityRoutes.performancebysales,
                        haveCharts: true
                    },
                    {
                        label: "Opportunity Quality Metrics Summary",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "opportunityqualitymetricssummary",
                        permissionName: ReportsOpportunityPermissions.opportunityqualitymetricssummary,
                        route: ReportsOpportunityRoutes.opportunityqualitymetricssummary,
                        haveCharts: false
                    },
                    {
                        label: "Opportunity Quality Metrics Details",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "opportunityqualitymetricsdetail",
                        permissionName: ReportsOpportunityPermissions.opportunityqualitymetricsdetail,
                        route: ReportsOpportunityRoutes.opportunityqualitymetricsdetail,
                        haveCharts: false
                    },
                    {
                        label: "Open Pipeline Summary",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "opportunitypipelinesummary",
                        permissionName: ReportsOpportunityPermissions.opportunitypipelinesummary,
                        route: ReportsOpportunityRoutes.opportunitypipelinesummary,
                        haveCharts: false
                    },
                    {
                        label: "Open Pipeline Details",
                        visible: false,
                        reportName: "",
                        escape: false,
                        reportType: "opportunitypipelinedetail",
                        permissionName: ReportsOpportunityPermissions.opportunitypipelinedetail,
                        route: ReportsOpportunityRoutes.opportunitypipelinedetail,
                        haveCharts: false
                    }
                ]
            },
            {
                label: "User Activity",
                expanded: false,
                visible: false,
                reportType: "user_activty_reports",
                permissionName: "Login Report",
                route: "user-activity",
                items: [
                    {
                        label: "User Activity by Users",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "userActivityByUsers",
                        permissionName: "User Device Info Report",
                        route: ReportsUserActivityRoutes.userActivityByUsers
                    },
                    {
                        label: "User Activity by Date",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "userActivityByDate",
                        permissionName: "Login History Report",
                        route: ReportsUserActivityRoutes.userActivityByDate
                    },
                    {
                        label: "User Activity by Activity Type",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "userActivityByActivityType",
                        permissionName: "Login History Report",
                        route: ReportsUserActivityRoutes.userActivityByActivityType
                    },
                ]
            },
            {
                label: "Audit",
                expanded: false,
                visible: false,
                reportType: 'audit_reports',
                permissionName: "Audit Report",
                route: "audit",
                items: [
                    {
                        label: "Audit Report",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsAuditRoutes['audit-report'],
                        permissionName: ReportsAuditPermissions['audit-report'],
                        route: ReportsAuditRoutes['audit-report'],
                    },
                ]
            },
        ]
    },
    {
        label: "Field Management",
        expanded: false,
        reportType: "field_management_reports",
        permissionName: "",
        route: null,
        haveCharts: true,
        items: [
            {
                label: "Visits ",
                expanded: true,
                visible: false,
                reportType: "visits_reports",
                permissionName: "Visit Report",
                route: "visits",
                haveCharts: true,
                items: [
                    {
                        label: ReportsVisitsLabelName.avareagefieldvisitbyrep,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.avareagefieldvisitbyrep,
                        permissionName: "",
                        route: ReportsVisitsRoutes.avareagefieldvisitbyrep
                    },
                    {
                        label: ReportsVisitsLabelName.getaccountfieldvisithistorybyrep,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.getaccountfieldvisithistorybyrep,
                        permissionName: "",
                        route: ReportsVisitsRoutes.getaccountfieldvisithistorybyrep,
                        haveCharts: true
                    },
                    {
                        label: ReportsVisitsLabelName.getleadfieldvisithistorybyrep,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.getleadfieldvisithistorybyrep,
                        permissionName: "",
                        route: ReportsVisitsRoutes.getleadfieldvisithistorybyrep,
                        haveCharts: true
                    },
                    {
                        label: ReportsVisitsLabelName.getterritorywiseaccountvisithistoryofrep,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep,
                        permissionName: "",
                        route: ReportsVisitsRoutes.getterritorywiseaccountvisithistoryofrep,
                        haveCharts: true
                    },
                    {
                        label: ReportsVisitsLabelName.getterritorywiseleadvisithistoryofrep,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.getterritorywiseleadvisithistoryofrep,
                        permissionName: "",
                        route: ReportsVisitsRoutes.getterritorywiseleadvisithistoryofrep,
                        haveCharts: true
                    },
                    {
                        label: ReportsVisitsLabelName.getterritorywiseaccountvisithistory,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.getterritorywiseaccountvisithistory,
                        permissionName: "",
                        route: ReportsVisitsRoutes.getterritorywiseaccountvisithistory
                    },
                    {
                        label: ReportsVisitsLabelName.getterritorywiseleadvisithistory,
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: ReportsVisitsNames.getterritorywiseleadvisithistory,
                        permissionName: "",
                        route: ReportsVisitsRoutes.getterritorywiseleadvisithistory
                    }
                ]
            },
            {
                label: "Questionnaire",
                expanded: false,
                visible: false,
                reportType: "questionnaire_reports",
                permissionName: "",
                route: "questionaire",
                items: [
                    {
                        label: "Response by Questionnaire Channels",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "qChannel",
                        permissionName: ReportsQuestionairePermissions.qChannel,
                        route: ReportsQuestionaireRoutes.qChannel
                    }
                ]
            },
            // {
            //     label: "Template",
            //     expanded: false,
            //     visible: false,
            //     reportType: "template_reports",
            //     permissionName: "",
            //     route: "template",
            //     items: [
            //         {
            //             label: "Template 1 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template1",
            //             permissionName: "",
            //             route: "template1",
            //         },
            //         {
            //             label: "Template 2 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template2",
            //             permissionName: "",
            //             route: "template2",
            //         },
            //         {
            //             label: "Template 3 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template3",
            //             permissionName: "",
            //             route: "template3",
            //         },
            //         {
            //             label: "Template 4 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template4",
            //             permissionName: "",
            //             route: "template4",
            //         },
            //         {
            //             label: "Template 5 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template5",
            //             permissionName: "",
            //             route: "template5",
            //         },
            //         {
            //             label: "Template 6 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template6",
            //             permissionName: "",
            //             route: "template6",
            //         },
            //         {
            //             label: "Template 7 ",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "template7",
            //             permissionName: "",
            //             route: "template7",
            //         }
            //     ]
            // }
        ]
    },
    {
        label: "Inventory",
        expanded: false,
        visible: false,
        reportType: "inventory_p_reports",
        permissionName: "",
        route: null,
        items: [
            {
                label: "Customers",
                expanded: false,
                visible: false,
                reportType: "customers_reports",
                permissionName: "Customers",
                route: "inventory",
                items: [
                    {
                        label: ReportsInventoryLabelName.accountsReceivable,
                        reportName: ReportsInventoryLabelName.accountsReceivable,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.accountsReceivable,
                        permissionName: ReportsPermissionNames.accountsReceivable,
                        route: ReportsInventoryRoutes.accountsReceivable
                    }
                ]
            },
            {
                label: "Inventory",
                expanded: false,
                visible: false,
                reportType: "inventory_reports",
                permissionName: "",
                route: "inventory",
                items: [
                    {
                        label: ReportsInventoryLabelName.inventoryValuationSummary,
                        reportName: ReportsInventoryLabelName.inventoryValuationSummary,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.inventoryValuationSummary,
                        permissionName: ReportsPermissionNames.inventoryValuationSummary,
                        route: ReportsInventoryRoutes.inventoryValuationSummary
                    },
                    {
                        label: ReportsInventoryLabelName.inventoryValuationDetail,
                        reportName: ReportsInventoryLabelName.inventoryValuationDetail,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.inventoryValuationDetail,
                        permissionName: ReportsPermissionNames.inventoryValuationDetail,
                        route: ReportsInventoryRoutes.inventoryValuationDetail
                    },
                    {
                        label: ReportsInventoryLabelName.inventorySnapshot,
                        reportName: ReportsInventoryLabelName.inventorySnapshot,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.inventorySnapshot,
                        permissionName: ReportsPermissionNames.inventorySnapshot,
                        route: ReportsInventoryRoutes.inventorySnapshot
                    },
                    {
                        label: ReportsInventoryLabelName.profitability,
                        reportName: ReportsInventoryLabelName.profitability,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.profitability,
                        permissionName: ReportsPermissionNames.profitability,
                        route: ReportsInventoryRoutes.profitability
                    }
                ]
            },
            {
                label: "Invoices",
                expanded: false,
                visible: false,
                reportType: "invoices_reports",
                permissionName: "Invoices",
                route: "inventory",
                items: [
                    {
                        label: ReportsInventoryLabelName.inventoryopeninvoice,
                        reportName: ReportsInventoryLabelName.inventoryopeninvoice,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.inventoryopeninvoice,
                        permissionName: ReportsPermissionNames.inventoryopeninvoice,
                        route: ReportsInventoryRoutes.inventoryopeninvoice
                    },
                    {
                        label: ReportsInventoryLabelName.inventoryallinvoice,
                        reportName: ReportsInventoryLabelName.inventoryallinvoice,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.inventoryallinvoice,
                        permissionName: ReportsPermissionNames.inventoryallinvoice,
                        route: ReportsInventoryRoutes.inventoryallinvoice
                    },
                    {
                        label: ReportsInventoryLabelName.invoiceByRep,
                        reportName: ReportsInventoryLabelName.invoiceByRep,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.invoiceByRep,
                        permissionName: ReportsPermissionNames.inventoryallinvoice,
                        route: ReportsInventoryRoutes.invoiceByRep
                    },
                    {
                        label: ReportsInventoryLabelName.invoiceByCustomer,
                        reportName: ReportsInventoryLabelName.invoiceByCustomer,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.invoiceByCustomer,
                        permissionName: ReportsPermissionNames.inventoryallinvoice,
                        route: ReportsInventoryRoutes.invoiceByCustomer
                    },
                    {
                        label: ReportsInventoryLabelName.profitByRep,
                        reportName: ReportsInventoryLabelName.profitByRep,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.profitByRep,
                        permissionName: ReportsPermissionNames.inventoryallinvoice,
                        route: ReportsInventoryRoutes.profitByRep
                    },
                    {
                        label: ReportsInventoryLabelName.profitByCustomer,
                        reportName: ReportsInventoryLabelName.profitByCustomer,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.profitByCustomer,
                        permissionName: ReportsPermissionNames.inventoryallinvoice,
                        route: ReportsInventoryRoutes.profitByCustomer
                    },
                    {
                        label: ReportsInventoryLabelName.shipping,
                        reportName: ReportsInventoryNames.shipping,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.shipping,
                        permissionName: ReportsPermissionNames.shipping,
                        route: ReportsInventoryRoutes.shipping
                    }
                ]
            },
            {
                label: "Sales Order",
                expanded: false,
                visible: false,
                reportType: "sales_order_reports",
                permissionName: "Sales Order",
                route: "inventory",
                items: [
                    {
                        label: ReportsInventoryLabelName.openSalesOrders,
                        reportName: ReportsInventoryLabelName.openSalesOrders,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.openSalesOrders,
                        permissionName: ReportsPermissionNames.openSalesOrders,
                        route: ReportsInventoryRoutes.openSalesOrders
                    },
                    {
                        label: ReportsInventoryLabelName.backSalesOrders,
                        reportName: ReportsInventoryLabelName.backSalesOrders,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.backSalesOrders,
                        permissionName: ReportsPermissionNames.backSalesOrders,
                        route: ReportsInventoryRoutes.backSalesOrders
                    },
                    {
                        label: ReportsInventoryLabelName.salesOrderCommited,
                        reportName: ReportsInventoryLabelName.salesOrderCommited,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.salesOrderCommited,
                        permissionName: ReportsPermissionNames.salesOrderCommited,
                        route: ReportsInventoryRoutes.salesOrderCommited
                    },
                    {
                        label: ReportsInventoryLabelName.picktimebypicker,
                        reportName: ReportsInventoryLabelName.picktimebypicker,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.picktimebypicker,
                        permissionName: ReportsPermissionNames.picktimebypicker,
                        route: ReportsInventoryRoutes.picktimebypicker
                    },
                    {
                        label: ReportsInventoryLabelName.picktimebylocation,
                        reportName: ReportsInventoryLabelName.picktimebylocation,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.picktimebylocation,
                        permissionName: ReportsPermissionNames.picktimebylocation,
                        route: ReportsInventoryRoutes.picktimebylocation
                    },
                    {
                        label: ReportsInventoryLabelName.packtimebypacker,
                        reportName: ReportsInventoryLabelName.packtimebypacker,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.packtimebypacker,
                        permissionName: ReportsPermissionNames.packtimebypacker,
                        route: ReportsInventoryRoutes.packtimebypacker
                    },
                    {
                        label: ReportsInventoryLabelName.packtimebylocation,
                        reportName: ReportsInventoryLabelName.packtimebylocation,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.packtimebylocation,
                        permissionName: ReportsPermissionNames.packtimebylocation,
                        route: ReportsInventoryRoutes.packtimebylocation
                    }
                ]
            },
            {
                label: "Vendor",
                expanded: false,
                visible: false,
                reportType: "vendor_reports",
                permissionName: "",
                route: "inventory",
                items: [
                    {
                        label: ReportsInventoryLabelName.accountsPayable,
                        reportName: ReportsInventoryNames.accountsPayable,
                        escape: false,
                        visible: false,
                        reportType: ReportsInventoryNames.accountsPayable,
                        permissionName: ReportsPermissionNames.accountsPayable,
                        route: ReportsInventoryRoutes.accountsPayable
                    }
                ]
            }
        ]
    },
    {
        label: "Finance",
        expanded: false,
        visible: false,
        reportType: "finance_reports",
        permissionName: "",
        route: null,
        items: [
            // {
            //     label: "Customers",
            //     expanded: false,
            //     visible: false,
            //     reportType: "customer_f_reports",
            //     permissionName: "Customer Report",
            //     route: "finance",
            //     items: [
            //         {
            //             label: "Income by Customer Detail",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "incomeCutomerDetail",
            //             permissionName: "Income By Customer Detail",
            //             route: ReportsInventoryRoutes.incomeCutomerDetail
            //         },
            //         {
            //             label: "Income by Customer Summary",
            //             reportName: "",
            //             escape: false,
            //             visible: false,
            //             reportType: "incomeCutomerSummary",
            //             permissionName: "Income By Customer Summary",
            //             route: ReportsInventoryRoutes.incomeCutomerSummary
            //         }
            //     ]
            // },
            {
                label: "Vendor",
                expanded: false,
                visible: false,
                reportType: "vendor_f_reports",
                permissionName: "Vendor Report",
                route: "finance",
                items: [
                    {
                        label: "Expenses by Vendor Detail",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "expensesVendorDetail",
                        permissionName: "Expenses By Vendor Detail",
                        route: ReportsInventoryRoutes.expensesVendorDetail
                    },
                    {
                        label: "Expenses by Vendor Summary",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "expensesVendorSummary",
                        permissionName: "Expenses By Vendor Summary",
                        route: ReportsInventoryRoutes.expensesVendorSummary
                    }
                ]
            },
            {
                label: "Organization",
                expanded: false,
                visible: false,
                reportType: "organization_reports",
                permissionName: "Organization Report",
                route: "finance",
                items: [
                    {
                        label: "Income & Expense Graph",
                        reportName: "Income & Expense Report",
                        escape: false,
                        visible: false,
                        reportType: "incomeExpenseGraph",
                        permissionName: "",
                        route: ReportsFinanceRoutes.incomeExpenseGraph
                    },
                    {
                        label: ReportsFinanceLabelName.pLStatement,
                        reportName: ReportsFinanceReportNames.pLStatement,
                        escape: false,
                        visible: false,
                        reportType: ReportsFinanceNames.pLStatement,
                        permissionName: "Profit & Loss (P&L)",
                        route: ReportsFinanceRoutes.pLStatement
                    },
                    {
                        label: ReportsFinanceLabelName.balance,
                        reportName: ReportsFinanceReportNames.balance,
                        escape: false,
                        visible: false,
                        reportType: ReportsFinanceNames.balance,
                        permissionName: "",
                        route: ReportsFinanceRoutes.balance
                    },
                ]
            }
        ]
    },
    {
        label: "Login & Device Info",
        expanded: false,
        visible: false,
        reportType: "login_device_reports",
        permissionName: "",
        route: null,
        items: [
            {
                label: "Login",
                expanded: false,
                visible: false,
                reportType: "login_reports",
                permissionName: "Login Report",
                route: "login",
                items: [
                    {
                        label: "User Device Info Reports",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "userDeviceInfo",
                        permissionName: "User Device Info Report",
                        route: ReportsLoginsRoutes.userDeviceInfo
                    },
                    {
                        label: "User Mobile Access Reports",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "userMobileAccess",
                        permissionName: "User Mobile Access Reports",
                        route: ReportsLoginsRoutes.userMobileAccess
                    },
                    {
                        label: "Login History Summary",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "loginHistory",
                        permissionName: "Login History Report",
                        route: ReportsLoginsRoutes.loginHistory
                    },
                    {
                        label: "Login History Details Reports",
                        reportName: "",
                        escape: false,
                        visible: false,
                        reportType: "loginHistoryDetails",
                        permissionName: "Login History Details Report",
                        route: ReportsLoginsRoutes.loginHistoryDetails
                    }
                ]
            }
        ]
    }

]



export const reportsMenuFlatData = () => {
    let flatMenus: any[] = [];
    const reportsMenuData2 = JSON.parse(JSON.stringify(reportsMenuData));
    reportsMenuData2.filter(menu => menu.reportType != "myfav_reports").map(firstLevel => {
        firstLevel?.items?.map(secondLevel => {
            secondLevel['parent'] = firstLevel;
            secondLevel?.items?.map(thirdLevel => {
                flatMenus.push({
                    parent: secondLevel,
                    ...thirdLevel
                })
            })
        })
    });

    return flatMenus;
}

export const reportsSecondLevelMenuData = () => {
    let flatMenus: any[] = [];
    const reportsMenuData2 = JSON.parse(JSON.stringify(reportsMenuData));
    reportsMenuData2.filter(menu => menu.reportType != "myfav_reports").map(firstLevel => {
        firstLevel?.items?.map(secondLevel => {
            secondLevel['parent'] = firstLevel;
            flatMenus.push(secondLevel)
        })
    });

    return flatMenus;
}

export const reportsChartsMenuData = () => {
    let flatMenus: any[] = [];
    const reportsMenuData2 = JSON.parse(JSON.stringify(reportsMenuData));
    reportsMenuData2.filter(menu => menu.reportType != "myfav_reports").map(firstLevel => {
        firstLevel?.items?.map(secondLevel => {
            if (secondLevel?.haveCharts) {
                secondLevel.items = secondLevel.items.filter(item => item?.haveCharts);
                secondLevel.items.map(item => item.parent = secondLevel);
                flatMenus.push(secondLevel)
            }

        })
    });

    return flatMenus;
}
